module.exports = __webpack_public_path__ + "static/media/h_7_72_shrink.8a21657d.gif";